<template>
  <v-container>
    <v-card flat>
      <v-container>
        <v-card-title v-if="this.$route.name === 'NewPartner'"> <h4 class="earth-color">ADD PARTNER</h4></v-card-title>
        <v-card-title v-if="this.$route.name === 'EditPartner'"> <h4 class="earth-color">UPDATE PARTNER</h4></v-card-title>
        <v-form @submit.prevent="postPartner()">
          <v-layout row wrap>
            <v-flex lg3 md4 sm12 xs12>
              <v-container fluid>
                <v-autocomplete label="Partner Type"
                                v-model="partner.partner_type"
                                :items="allPartnerTypes"
                                :rules="[v => !!v || 'Partner Type is required']"
                                required
                                item-text="name"
                                item-value="public_id"
                                :loading="$loadingTrue"
                                @change="partnerTypeSelected"></v-autocomplete>
              </v-container>
            </v-flex>
            <v-flex lg3 md4 sm12 xs12>
              <v-container>
                <v-text-field label="Name"
                              v-model="partner.name"
                              :rules="requiredRules"
                              required></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg3 md4 sm12 xs12>
              <v-container>
                <v-text-field label="Customer Code (KES)"
                              v-model="partner.customer_code"
                              required></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg3 md4 sm12 xs12>
              <v-container>
                <v-text-field label="Customer Code (USD)"
                              v-model="partner.customer_code_usd"
                              required></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg4 md4 sm12 xs12>
              <v-container>
                <v-text-field label="KRA Pin Number"
                              v-model="partner.kra_pin_number"
                              :rules="requiredRules"
                              required></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg4 md4 sm12 xs12>
              <v-container>
                <v-text-field label="Postal Address"
                              v-model="partner.postal_address"
                              :rules="requiredRules"
                              required></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg4 md4 sm12 xs12>
              <v-container>
                <v-text-field label="Postal Code"
                              v-model="partner.postal_code"
                              :rules="requiredRules"
                              required
                              type="number"></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-text-field label="Email"
                              v-model="partner.email"
                              :rules="requiredRules"
                              required
                              type="email"></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-text-field label="Telephone"
                              v-model="partner.tel_number"
                              :rules="requiredRules"
                              required
                              type="tel"></v-text-field>
              </v-container>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="this.$route.name === 'NewPartner' || this.$route.name === 'EditPartner'">
            <v-flex lg12 v-if="partner.partner_type !== '6bac8c28'">
              <v-flex lg12 md12 sm12 xs12>
                <v-container>
                  <h3 class="earth-color">PARTNER USER DETAILS </h3>
                </v-container>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12>
                <v-container>
                  <v-text-field label="First Name"
                                v-model="partner.first_name"
                                :rules="requiredRules"
                                required></v-text-field>
                </v-container>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12>
                <v-container>
                  <v-text-field label="Last Name"
                                v-model="partner.last_name"
                                :rules="requiredRules"
                                required></v-text-field>
                </v-container>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12>
                <v-container>
                  <v-text-field label="Email"
                                v-model="partner.uemail"
                                :rules="requiredRules"
                                required
                                type="email"></v-text-field>
                </v-container>
              </v-flex>
              <v-flex lg6 md6 sm12 xs12>
                <v-container>
                  <v-text-field label="Phone Number (e.g. 1-347382374)"
                                placeholder="code - number e.g. 1-347382374"
                                v-model="partner.phone_number"
                                :rules="requiredRules"
                                required
                                type="tel"></v-text-field>
                </v-container>
              </v-flex>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex lg12 md12 sm12 xs12>
              <v-container>
                <h3 class="earth-color">ASSIGN DESTINATIONS</h3>
              </v-container>
            </v-flex>
            <v-flex lg12>
              <v-expansion-panel popout>
                <v-expansion-panel-content>
                  <div slot="header"><h4 class="earth" style="margin-top: 10px">DESTINATIONS ({{partner.destinations.length}})</h4></div>
                  <v-card>
                    <v-container>
                      <v-card-text v-for="(destination, idx) in allDestinations" :key="idx">
                        <input class="form-check-input" type="checkbox" :value="destination.destination_public_id" :id="destination.destination_public_id" v-model="partner.destinations" @click="isDestinationSelected($event)"> {{destination.destination_name}}
                      </v-card-text>
                    </v-container>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!--</v-container>-->
            </v-flex>
          </v-layout>
          <v-flex lg12 md12 sm12 xs12>
            <v-btn :depressed="true" block v-if="route === 'NewPartner'" color="primary" type="submit" :loading="this.$store.state.LoadingStore.loading">Create Partner</v-btn>
            <v-btn :depressed="true" block v-if="route === 'EditPartner'" color="warning" type="submit" :loading="this.$store.state.LoadingStore.loading">Update Partner</v-btn>
          </v-flex>
        </v-form>
      </v-container>
    </v-card>
    {{updatePartner}}
  </v-container>
</template>

<script>
  export default {
    data() {
      return {
        route: this.$route.name,
        requiredRules: [
          v => !!v || 'This field is required'
        ],
        partner: {
          destinations: [],
          customer_code: '',
          customer_code_usd: '',
          partner_type: '',
          name: '',
          postal_address: '',
          postal_code: '',
          email: '',
          tel_number: '',
          public_id: this.$route.params.partner_id,
          first_name: '',
          last_name: '',
          uemail: '',
          phone_number: '254',
          special_discount: 0,
          user_type: '35fcfdaf',
          kra_pin_number: '',
          session_id: localStorage.getItem('lkjhgfdsa')
        }
      }
    },
    methods: {
      isDestinationSelected: function (e) {
        if (this.$route.name === 'EditPartner') {
          if (e.target.checked) {
            this.partner.destinations.push(e.target.value)
          } else {
            let value = this.partner.destinations.indexOf(e.target.value)
            if (value !== -1) {
              this.partner.destinations.splice(value, 1)
            }
          }
        } else {
          if (e.target.checked) {
            this.partner.destinations.push(e.target.value)
          } else {
            let value = this.partner.destinations.indexOf(e.target.value)
            if (value !== -1) {
              this.partner.destinations.splice(value, 1)
            }
          }
        }
      },
      partnerTypeSelected: function (type_id) {
        let instance = this
        this.allPartnerTypes.map((type) => {

        })
      },
      postPartner: function () {
        if (this.$route.name === 'EditPartner') {
          this.$store.dispatch('update_partner', this.partner)
        } else {
          this.$store.dispatch('post_partner', this.partner)
        }
      }
    },
    beforeCreate() {
      this.$store.dispatch('get_all_destinations')
      this.$store.dispatch('get_all_partner_types')
    },
    created() {
      if (this.$route.name === 'EditPartner') {
        this.$store.dispatch('get_partner', this.$route.params.partner_id)
        this.$store.dispatch('get_institution_destinations', this.$route.params.partner_id)
      }
    }
  }
</script>

<style>
</style>
